import Vue from 'vue'
import moment from 'moment'

import qs from 'qs'
import { i18n } from '../langs'

const datetimeFormat = 'YYYY-MM-DD HH:mm:ss'

Vue.filter('date', function(date) {
  var converted = moment(date, datetimeFormat);
  if (!converted.isValid()) {
    return 'N/A'
  }
  return converted.format('D MMM, YYYY')
})

Vue.filter('formatSize', function(size) {
  if (size > 1024 * 1024 * 1024 * 1024) {
    return (size / 1024 / 1024 / 1024 / 1024).toFixed(2) + ' TB'
  } else if (size > 1024 * 1024 * 1024) {
    return (size / 1024 / 1024 / 1024).toFixed(2) + ' GB'
  } else if (size > 1024 * 1024) {
    return (size / 1024 / 1024).toFixed(2) + ' MB'
  } else if (size > 1024) {
    return (size / 1024).toFixed(2) + ' KB'
  }
  return size.toString() + ' B'
})

Vue.filter('isEmpty', function(input) {
  if (!input) {
    return 'N/A'
  }
  return input
})

Vue.filter('removeEmptyObj', function(input) {
  var parameters = JSON.parse(JSON.stringify(input));
  if (!(parameters instanceof Array) && Object.keys(parameters).length != 0) {
    for (var propName in parameters) {
      if (parameters[propName] === null || parameters[propName] === undefined || parameters[propName].length == 0) {
        delete parameters[propName];
      }
    }
  }
  return parameters;
})

Vue.filter('isEmptyObject', function(obj) {
  if (obj == null) {
    return true;
  }
  for (var key in obj) {
    if (obj.hasOwnProperty(key))
      return false;
  }
  return true;
})



// WEBPACK FOOTER //
// ./src/utils/filters.js